import { IconTypes } from "../../Enums/UiEnums";

export enum AuditAction {
    All = "All",
    View = "View",
    Insert = "Insert",
    Update = "Update",
    Delete = "Delete",
    Print = "Print"
}

export const AuditActionDictionary: Record<AuditAction, AuditActionModel> = {
    [AuditAction.All]:{name: AuditAction.All, order: 1},
    [AuditAction.Delete]: {name: AuditAction.Delete, order: 2},
    [AuditAction.Insert]: {name: AuditAction.Insert, order: 3},
    [AuditAction.Print]: {name: AuditAction.Print, order: 4},
    [AuditAction.Update]: {name: AuditAction.Update, order: 5},
    [AuditAction.View]: {name: AuditAction.View, order: 6}
}

export interface AuditActionModel {
    name: AuditAction, 
    order: number, 
    iconType?: IconTypes
}